/**
 * Fonction commune pour détecter les messages non lus
 * @param {Object} message - Le message à vérifier
 * @returns {boolean} - true si le message est non lu
 */
export const isUnreadMessage = (message) => {
  // Ne pas notifier les messages vides
  if (!message.content || message.content.trim() === '') {
    return false;
  }
  // Critère qui fonctionne : messages envoyés par le système (customerAuthor === null) et non lus
  const isUnread = message.customerAuthor === null && message.isRead === false;
  
  // Log pour déboguer (seulement pour les messages non lus)
  // if (isUnread) {
  //   console.log('🔔 Message non lu détecté:', {
  //     id: message.id,
  //     author: message.author,
  //     customerAuthor: message.customerAuthor,
  //     isRead: message.isRead,
  //     content: message.content?.substring(0, 30)
  //   });
  // }
  
  return isUnread;
};

/**
 * Compte le nombre total de messages non lus dans une liste de conversations
 * @param {Array} conversations - Liste des conversations
 * @returns {number} - Nombre total de messages non lus
 */
export const countUnreadMessages = (conversations) => {
  let totalUnread = 0;
  
  conversations.forEach(conversation => {
    const unread = conversation.messages.filter(isUnreadMessage).length;
    totalUnread += unread;
  });
  
  return totalUnread;
};

/**
 * Filtre les messages non lus d'une liste de messages
 * @param {Array} messages - Liste des messages
 * @returns {Array} - Liste des messages non lus
 */
export const getUnreadMessages = (messages) => {
  return messages.filter(isUnreadMessage);
}; 